























































import Vue from 'vue'
import store from '@/store'

export default Vue.extend({
  data: () => ({
    mobileNavVisible: false,
    store,
  }),

  computed: {
    errorMessage(): string {
      return this.store.state.errorMessage
    },

    isBusy(): boolean {
      return this.store.state.isBusy
    },

    year(): number {
      const d = new Date()
      return d.getFullYear()
    },
  },

  methods: {
    clearError() {
      this.store.clearErrorMessage()
    },

    closeMobileMenu() {
      this.mobileNavVisible = false
    },

    goHome() {
      this.$router.push('/')
    },

    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
    },
  },

  watch: {
    $route(to, from) { // eslint-disable-line @typescript-eslint/no-unused-vars
      this.mobileNavVisible = false
    },
  },
})
